<header>
  <igx-navbar title="Talent Assessments Platform" [actionButtonIcon]="actionIcon"
    [isActionButtonVisible]="actionVisible" (onAction)="menuClicked($event)">
    <app-auth-status></app-auth-status>
  </igx-navbar>
</header>